import type { ReactNode } from 'react';

import type { ClientFormSectionStatus } from '../models/ClientFormSectionStatus';
import type { FormSection } from '../models/Form';

export type FormStepWrapperProps = {
  step: FormSection;
};

export type FormActionWrapperProps = {
  isLast: boolean;
  children?: ReactNode | undefined;
};

export type FormStepTitleProviderProps = {
  step: FormSection;
  mode: FormRendererMode;
  stepStatus: ClientFormSectionStatus;
};

export enum FormRendererMode {
  EditView,
  OverviewView,
  PreviewView,
}
